(function () {
  var IDS_KEY = 'sp_wishlist';
  var DATA_KEY = 'sp_wishlist_data';

  function getIds() {
    try { return JSON.parse(localStorage.getItem(IDS_KEY) || '[]'); } catch (e) { return []; }
  }

  function getData() {
    try { return JSON.parse(localStorage.getItem(DATA_KEY) || '{}'); } catch (e) { return {}; }
  }

  function saveIds(ids) {
    localStorage.setItem(IDS_KEY, JSON.stringify(ids));
  }

  function inList(id) {
    return getIds().indexOf(String(id)) > -1;
  }

  function toggle(id, meta) {
    var ids = getIds();
    var idx = ids.indexOf(String(id));
    if (idx > -1) {
      ids.splice(idx, 1);
    } else {
      ids.push(String(id));
      if (meta) {
        var data = getData();
        data[String(id)] = meta;
        localStorage.setItem(DATA_KEY, JSON.stringify(data));
      }
    }
    saveIds(ids);
    return idx === -1;
  }

  function refreshButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var active = inList(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      var lbl = btn.querySelector('.wishlist-btn__label');
      if (lbl) lbl.textContent = active ? 'Saved' : 'Add to Wishlist';
      var icon = btn.querySelector('.wishlist-btn__icon');
      if (icon) icon.setAttribute('fill', active ? 'currentColor' : 'none');
    });
  }

  function refreshCount() {
    var n = getIds().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function createDrawer() {
    if (document.getElementById('wishlist-drawer')) return;
    var el = document.createElement('div');
    el.id = 'wishlist-drawer';
    el.innerHTML =
      '<div class="wishlist-drawer__overlay" id="wishlist-drawer-overlay"></div>' +
      '<div class="wishlist-drawer__panel" role="dialog" aria-modal="true" aria-label="Your wishlist">' +
        '<div class="wishlist-drawer__header">' +
          '<p class="wishlist-drawer__title">My Wishlist</p>' +
          '<button type="button" id="wishlist-drawer-close" class="wishlist-drawer__close" aria-label="Close">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="wishlist-drawer__body" id="wishlist-drawer-body"></div>' +
        '<div class="wishlist-drawer__footer" id="wishlist-drawer-footer">' +
          '<a href="/pages/my-wishlist" class="button wishlist-drawer__view-all">View wishlist</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    document.getElementById('wishlist-drawer-overlay').addEventListener('click', closeDrawer);
    document.getElementById('wishlist-drawer-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function openDrawer() {
    createDrawer();
    renderDrawerItems();
    var drawer = document.getElementById('wishlist-drawer');
    drawer.classList.add('is-open');
    document.body.classList.add('wishlist-overflow-hidden');
    var closeBtn = document.getElementById('wishlist-drawer-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer) drawer.classList.remove('is-open');
    document.body.classList.remove('wishlist-overflow-hidden');
  }

  function renderDrawerItems() {
    var body = document.getElementById('wishlist-drawer-body');
    var footer = document.getElementById('wishlist-drawer-footer');
    if (!body) return;

    var ids = getIds();
    var data = getData();

    if (!ids.length) {
      body.innerHTML = '<div class="wishlist-drawer__empty"><p>Your wishlist is empty.</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';

    body.innerHTML = ids.map(function (id) {
      var p = data[id];
      if (!p) return '';
      return '<div class="wishlist-drawer__item" data-drawer-item="' + id + '">' +
        '<a href="/products/' + p.handle + '" class="wishlist-drawer__item-image-link" tabindex="-1">' +
        '<img src="' + p.image + '" alt="' + p.title + '" class="wishlist-drawer__item-image" loading="lazy">' +
        '</a>' +
        '<div class="wishlist-drawer__item-info">' +
        '<a href="/products/' + p.handle + '" class="wishlist-drawer__item-title">' + p.title + '</a>' +
        '<p class="wishlist-drawer__item-price">' + p.price + '</p>' +
        '<button class="wishlist-drawer__item-remove" data-drawer-remove="' + id + '">Remove</button>' +
        '</div>' +
        '</div>';
    }).join('');

    body.querySelectorAll('[data-drawer-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.drawerRemove;
        var ids = getIds();
        var idx = ids.indexOf(id);
        if (idx > -1) { ids.splice(idx, 1); saveIds(ids); }
        var item = body.querySelector('[data-drawer-item="' + id + '"]');
        if (item) item.remove();
        refreshButtons();
        refreshCount();
        if (!getIds().length) renderDrawerItems();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.dataset.productId, {
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice
    });
    refreshButtons();
    refreshCount();
    if (added) {
      openDrawer();
    } else {
      if (document.getElementById('wishlist-drawer') && document.getElementById('wishlist-drawer').classList.contains('is-open')) {
        renderDrawerItems();
      }
    }
  });

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var ids = getIds();
    var data = getData();

    if (!ids.length) {
      root.innerHTML = '<div class="wishlist-empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="button">Shop now</a></div>';
      return;
    }

    var cards = ids.map(function (id) {
      var p = data[id];
      if (!p) return '';
      return '<div class="wishlist-card" data-wishlist-card="' + id + '">' +
        '<a href="/products/' + p.handle + '" class="wishlist-card__image-link">' +
        '<img src="' + p.image + '" alt="' + p.title + '" class="wishlist-card__image" loading="lazy">' +
        '</a>' +
        '<div class="wishlist-card__body">' +
        '<a href="/products/' + p.handle + '" class="wishlist-card__title">' + p.title + '</a>' +
        '<p class="wishlist-card__price">' + p.price + '</p>' +
        '<div class="wishlist-card__actions">' +
        '<a href="/products/' + p.handle + '" class="button">View product</a>' +
        '<button class="button button--outline" data-remove="' + id + '">Remove</button>' +
        '</div></div></div>';
    }).join('');

    root.innerHTML = '<div class="wishlist-grid">' + cards + '</div>';

    root.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.remove;
        var ids = getIds();
        var idx = ids.indexOf(id);
        if (idx > -1) { ids.splice(idx, 1); saveIds(ids); }
        var card = root.querySelector('[data-wishlist-card="' + id + '"]');
        if (card) card.remove();
        refreshCount();
        refreshButtons();
        if (!getIds().length) renderPage();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    createDrawer();
    refreshButtons();
    refreshCount();
    renderPage();
  });

  window.Wishlist = { inList: inList, getIds: getIds, openDrawer: openDrawer };
}());
